module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    staticClass: "window-video",
    style: (_vm.data.style),
    attrs: {
      "autoplay": "",
      "loop": "",
      "playsinline": "",
      "muted": ""
    },
    on: {
      "click": function($event) {
        _vm.playJoke($event)
      }
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.data.src,
      "type": "video/mp4"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71545a25"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/website/WindowVideo.vue
// module id = 709
// module chunks = 64